import { useQuery } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
  GetDigitalSignatureSettingsClientRequest,
  GetDigitalSignatureSettingsClientResponse,
} from '../../../@types/digitalSignature/getDigitalSignatureSettings'
import { api } from '../../../Services/API'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { QUERY_KEYS } from '../../../constants/queryKeys'

const request = async (payload: GetDigitalSignatureSettingsClientRequest) => {
  const response = await api.post<GetDigitalSignatureSettingsClientResponse>(
    API_ROUTES.getDigitalSignatureSettings,
    payload,
  )

  return response.data
}

export const useGetDigitalSignatureSettings = (
  payload: GetDigitalSignatureSettingsClientRequest,
  isEnabled: boolean,
) => {
  return useQuery<
    GetDigitalSignatureSettingsClientResponse,
    AxiosError<ErrorHandling[]>
  >({
    queryKey: [QUERY_KEYS.getDigitalSignatureSettings, payload],
    queryFn: () => request(payload),
    enabled: isEnabled,
  })
}
